"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgTvPlay(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M13 31a1 1 0 100 2v-2zm14 2a1 1 0 000-2v2zm-14 0h14v-2H13v2z", fill: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("rect", { x: 3, y: 8, width: 34, height: 20, rx: 1.831, stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 14.625c0-.287.302-.474.56-.345l6.617 3.309a.387.387 0 010 .691l-6.618 3.31a.387.387 0 01-.559-.346v-6.619z", fill: "currentColor" }, void 0)] }), void 0));
}
exports.default = SvgTvPlay;
//# sourceMappingURL=TvPlay.js.map